// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"e601507c","391":"41b08a33","648":"b048f05d","760":"c9ee1925"}[chunkId] + ".chunk.css";
};